import { render, staticRenderFns } from "./UserDisplayDialog.vue?vue&type=template&id=4651ec1c"
import script from "./UserDisplayDialog.vue?vue&type=script&lang=js"
export * from "./UserDisplayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports